import { Routes, Route } from 'react-router-dom';
import Home from './pages/home/Home';
import Event19 from './pages/event19/Event19';
import Footer from './containers/footer/Footer';
import Arrow from './components/arrow/Arrow';
import ScrollToTop from './components/scrollToTop/ScrollToTop';
import styles from './App.module.css';
import Event18 from './pages/event18/Event18';
import Event17 from './pages/event17/Event17';

function App() {
  return (
    <>
      <div className={styles.container}>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="2019" element={<Event19 />} />
          <Route path="2018" element={<Event18 />} />
          <Route path="2017" element={<Event17 />} />
        </Routes>
      </div>
      <Arrow />
      <Footer />
    </>
  );
}

export default App;
